import { modals } from "@mantine/modals"
import { SessionExpiredContent } from "@features/auth/components/SessionExpiredModal"
import { LocalStorageSession } from "@shared/utils/local-storage-session"

const MODAL_ID = "session-expired"

let pendingReLogin: Promise<string | null> | null = null

/**
 * Pide al usuario volver a iniciar sesión sin salir de la página actual.
 * Resuelve con el nuevo token, o null si eligió cerrar sesión (en ese caso ya se lo redirige a /login).
 */
export const requestReLogin = (email: string, tenantId: string): Promise<string | null> => {
  pendingReLogin ??= new Promise<string | null>((resolve) => {
    const onDone = (token: string | null) => {
      modals.close(MODAL_ID)
      resolve(token)
      if (!token) {
        void LocalStorageSession.clearSession().then(() => {
          globalThis.location.href = "/login"
        })
      }
    }
    modals.open({
      modalId: MODAL_ID,
      title: "Sesión expirada",
      centered: true,
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
      children: <SessionExpiredContent email={email} tenantId={tenantId} onDone={onDone} />
    })
  }).finally(() => {
    pendingReLogin = null
  })
  return pendingReLogin
}
